
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ProgressComponent from "../../../components/general/ProgressComponent";
import Form from "react-bootstrap/Form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    BASE_URL,
    GET_DEVICES_LOGS,
    UPDATE_DEVICES_LOGS,
} from "../../../env";
import {
    getRecords,
    isSuccess,
    updateRecords,
    toastSuccessMessages,
    toastErrorMessages,
    deleteRecords,
    catchAsync,
} from "../../../helper/helper";
// import EditPbsPlans from "./EditPbsPlans";
import moment from "moment";
import { hasAnyPermissions } from "../../../permission_advance/PermissionColumn";
function DevicesStatus() {
    const [status, setStatus] = useState("enabled");
    const [userData, setUserData] = useState([]);
    const statusClassMapping = {
        enabled: "background-success text-white",
        disabled: "background-danger text-dark",
    };
    const apiQuery = {
        skip: 0,
        limit: 10,
        sortOrder: 1
    };


    const [isHolidaysGroup, setIsHolidaysGroup] = useState(false);
    const [search, setSearch] = useState("");
    const [filterSearch, setFilterSearch] = useState();
    const [isLoading, setIsLoading] = useState(true);

    // Getting records from DB
    const processFetchRecords = (method, data) => {
        if (method === "get" && data?.status === isSuccess) {
            const actionRecentIncidentsData = data?.data?.staffDevices
            const medicineListsData = actionRecentIncidentsData?.map((item) => item);
            // console.log("🚀 ~ processFetchRecords ~ actionRecentIncidentsData:", actionRecentIncidentsData)
            setUserData(medicineListsData);
            setFilterSearch(medicineListsData);
            setIsLoading(false);
            // toastSuccessMessages(toast.success, data?.message, "", 500, 500);
        } else if (method === "update" && data?.status === isSuccess) {
            setIsHolidaysGroup(true)
            toastSuccessMessages(toast.success, data?.message, "", 500, 500);
            setTimeout(() => {
                setIsHolidaysGroup(false);
            }, 2000);
        }
    };

    const fetchAllRecords = catchAsync(async (req, res) => {
        const query = req ? req : apiQuery
        const response = await getRecords(GET_DEVICES_LOGS, query);
        processFetchRecords("get", response);
    });



    useEffect(() => {
        fetchAllRecords();
    }, []);

    useEffect(() => {

        if (!isLoading) {
            const apiQuery = {
                skip: 0,
                limit: 10000,
            };
            fetchAllRecords(apiQuery)
        }
    }, [isLoading]);



    const updateStaffHoliday = catchAsync(async (req) => {
        try {
            const response = await updateRecords(UPDATE_DEVICES_LOGS, req);
            console.log("🚀 ~ updateStaffHoliday ~ response:", response);
            processFetchRecords("update", response);
        } catch (error) {
            console.error("Error updating staff holidays:", error);
        }
    });

    const [holidayRequestStatus, setHolidayRequestStatus] = useState(null);

    useEffect(() => {
        const updateStatus = async () => {
            if (holidayRequestStatus) {
                try {
                    await updateStaffHoliday(holidayRequestStatus);
                    fetchAllRecords();
                } catch (error) {
                    console.error("Error updating status:", error);
                }
            }
        };
        updateStatus();
    }, [holidayRequestStatus]);

    // Table Columns
    const handleStatusChange = (event, row) => {
        setHolidayRequestStatus({
            id: row?._id,
            status: event?.target?.value,
        });
    };

    const columns = [
        {
            name: "Staff Member",
            selector: (row) => {
                return (
                    <>
                        <span className="usersNameInfo m-2 ml-0">
                            <span className="userImage mr-3">
                                <img src={BASE_URL + row?.staffId?.user?.profile_picture_url} />
                            </span>
                            <span className="userInfo">
                                <span className="nameBlock">{row?.staffId?.staffMemberName}</span>
                                <span className="nameBlock capitalizeTransform"><small>{row?.staffId?.staffDesignation}</small></span>
                            </span>
                        </span>
                    </>
                );
            },
        },

        {
            name: "Device ID",
            selector: (row) => (
                <p className="m-0">
                    {row?.deviceId}
                </p>
            ),
        },
        {
            name: "Device Name",
            selector: (row) => (
                <p className="m-0">
                    {row?.deviceName}
                </p>
            ),
        },
        ...(hasAnyPermissions(["create", "update", "delete"], "Medicine List")
            ? [
                {
                    name: "Action",
                    selector: (row) => {
                        return (
                            <div className="actionColumns individualReviewsActions">
                                <div className={`select-box status-select-box ${statusClassMapping[row.status]}`}>
                                    <Form.Select
                                        aria-label="Status select"
                                        value={row.status}
                                        onChange={(e) => handleStatusChange(e, row)}
                                    >
                                        <option value="enabled">Enabled</option>
                                        <option value="disabled">Disabled</option>
                                    </Form.Select>
                                </div>
                            </div>
                        );
                    },
                    width: "15%",
                    center: true,
                    wrap: true,
                },
            ]
            : []),
    ];


    // Search Filter
    useEffect(() => {
        const result = userData.filter((user) => {
            const filterStaffMemberName = user?.staffId?.staffMemberName
            return filterStaffMemberName.toLowerCase().match(search.toLowerCase());
        });
        setFilterSearch(result);
    }, [search, userData]);



    return (
        <>
            <div className="mainContent pbsPlan">
                <div className="dataTableWrapper">
                    <DataTable
                        className="maxWidthTable"
                        columns={columns}
                        data={filterSearch}
                        pagination
                        paginationRowsPerPageOptions={[1, 25, 50, 100]}
                        paginationPerPage={10}
                        fixedHeader
                        fixedHeaderScrollHeight="520px"
                        highlightOnHover
                        responsive={true}
                        subHeader={true}
                        subHeaderComponent={
                            <div className="searchContainer">
                                <div className="searchTextBox">
                                    <input
                                        type="text"
                                        placeholder="Search by Staff Member"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>
                            </div>
                        }
                        subHeaderAlign="left"
                        subHeaderWrapperProps={{ style: { padding: 0, margin: 0 } }}
                        progressPending={isLoading}
                        progressComponent={<ProgressComponent />}
                    />
                </div>
            </div>
            {isHolidaysGroup && <ToastContainer />}
        </>
    );
}

export default DevicesStatus